import { isTransparent, upgradeColor } from '@wix/shoutout-email-model-v3';
export const getUpgradedColor = (color) => color && isTransparent(color) ? 'transparent' : upgradeColor(color);
//# sourceMappingURL=get-upgraded-color.js.map